import * as Types from './types';
import { DataState } from '../types';
import { AnyAction } from 'redux';

const initialState = {
  isSessionConfirmationExcludedLoading: false,
  isSessionConfirmationExcludedError: null,
  isSessionConfirmationExcluded: false
};

export const dataReducer = (state: DataState = initialState, action: AnyAction) => {
  switch (action.type) {
    case Types.SESSION_CONFIRMATION_EXCLUSION_GET: {
      return {
        ...state,
        isSessionConfirmationExcludedLoading: false,
        isSessionConfirmationExcludedError: null,
        isSessionConfirmationExcluded: action.payload
      };
    }
    case Types.SESSION_CONFIRMATION_EXCLUSION_LOADING: {
      return {
        ...state,
        isSessionConfirmationExcludedLoading: true
      };
    }
    case Types.SESSION_CONFIRMATION_EXCLUSION_ERROR: {
      return {
        ...state,
        isSessionConfirmationExcludedLoading: false,
        isSessionConfirmationExcludedError: action.payload
      };
    }

    default:
      return state;
  }
};
